<div class="d-flex justify-content-end align-items-center">
  <ng-container *ngFor="let button of actionButtons">
    <div
      class="tooltip-wrapper-div"
      [nbTooltip]="
        (button?.disabledForSaaS &&
          featureFlagService?.isSaaSCP &&
          SAAS_ONLY_FEATURE_TOOL_TIP) ||
        (userAuthoritiesService.isActionDisabled(
          button?.action,
          clusterId,
          button?.actionsList
        ) &&
          userAuthoritiesService?.buttonDisabledTooltip) ||
        button?.nbTooltip
      "
      [nbTooltipDisabled]="
        !(button?.disabledForSaaS && featureFlagService?.isSaaSCP) &&
        !button?.nbTooltip &&
        !userAuthoritiesService.isActionDisabled(
          button?.action,
          clusterId,
          button?.actionsList
        )
      "
    >
      <button
        id="{{ button.id }}"
        nbButton
        size="small"
        class="left-margin position-relative"
        [ngClass]="{
          buttonClass: !(
            button?.disabled ||
            userAuthoritiesService.isActionDisabled(
              button?.action,
              clusterId,
              button?.actionsList
            ) ||
            (button?.disabledForSaaS && featureFlagService?.isSaaSCP)
          )
        }"
        *ngIf="
          (button?.buttonType === 'primary' ||
            button?.buttonType === 'secondary') &&
          !button?.hidden
        "
        [status]="
          button?.buttonType === 'primary'
            ? 'primary'
            : button?.status
            ? button?.status
            : 'danger'
        "
        [disabled]="
          button?.disabled ||
          userAuthoritiesService.isActionDisabled(
            button?.action,
            clusterId,
            button?.actionsList
          ) ||
          (button?.disabledForSaaS && featureFlagService?.isSaaSCP)
        "
        [nbSpinner]="button?.loading"
        (click)="onButtonClick(button)"
        [appearance]="
          button?.buttonType === 'primary'
            ? 'filled'
            : button?.appearance
            ? button?.appearance
            : 'outline'
        "
        [attr.data-action-id]="button.dataAttrActionId"
      >
        <nb-icon
          *ngIf="button?.icon"
          [icon]="button?.icon"
          [ngClass]="{
            'icon-disabled': userAuthoritiesService.isActionDisabled(
              button?.action,
              clusterId,
              button?.actionsList
            )
          }"
          [pack]="button?.pack || 'eva'"
        ></nb-icon>
        <nb-badge
          class="custom-button-badge"
          *ngIf="button?.badgeText"
          [text]="button?.badgeText"
          [status]="button?.badgeStatus || 'success'"
          [position]="button.badgePosition || 'top right'"
        ></nb-badge>
        {{ button?.title }}
      </button>
    </div>
  </ng-container>
  <div class="dropdown" *ngIf="tertiaryButtons?.length !== 0">
    <div
      id="more-actions"
      class="more-button cursor-pointer"
      id="dropdownMenuButton"
      data-toggle="dropdown"
      aria-haspopup="true"
      aria-expanded="false"
      (click)="onClickHandleOption()"
    >
      <nb-icon icon="three-dots" pack="fci"> </nb-icon>
      <nb-icon
        icon="dot"
        pack="fci"
        *ngIf="showHighlighterForMoreActions"
        class="more-actions-highlighter"
      ></nb-icon>
    </div>
    <div
      class="dropdown-menu dropdown-menu-right p-0 px-2 pt-2"
      aria-labelledby="dropdownMenuButton"
      style="z-index: 2"
      (click)="$event.stopPropagation()"
    >
      <ng-container *ngFor="let button of tertiaryButtons">
        <div class="d-flex align-items-center mb-2" *ngIf="!button?.hidden">
          <div
            class="tooltip-wrapper-div"
            [nbTooltip]="
              userAuthoritiesService.isActionDisabled(
                button?.action,
                clusterId,
                button?.actionsList
              )
                ? userAuthoritiesService.buttonDisabledTooltip
                : button?.nbTooltip
            "
            [nbTooltipDisabled]="
              !button?.nbTooltip &&
              !userAuthoritiesService.isActionDisabled(
                button?.action,
                clusterId,
                button?.actionsList
              )
            "
            style="width: 100%"
          >
            <button
              id="{{ button.id }}"
              nbButton
              size="small"
              fullWidth
              [status]="button.status ? button.status : 'primary'"
              [disabled]="
                button?.disabled ||
                userAuthoritiesService.isActionDisabled(
                  button?.action,
                  clusterId,
                  button?.actionsList
                )
              "
              class="position-relative"
              (click)="onButtonClick(button)"
              [nbSpinner]="button?.loading"
              [appearance]="button.appearance || 'outline'"
              [attr.data-action-id]="button.dataAttrActionId"
            >
              <nb-icon
                *ngIf="button?.icon"
                [icon]="button?.icon"
                [ngClass]="{
                  'icon-disabled': userAuthoritiesService.isActionDisabled(
                    button?.action,
                    clusterId,
                    button?.actionsList
                  )
                }"
                [pack]="button?.pack || 'eva'"
                [ngStyle]="{ 'font-size': button?.iconSize }"
              ></nb-icon>
              <nb-badge
                class="custom-button-badge"
                *ngIf="button?.badgeText"
                [text]="button?.badgeText"
                [status]="button?.badgeStatus || 'success'"
                [position]="button.badgePosition || 'top right'"
              ></nb-badge>
              {{ button?.title }}
            </button>
          </div>
          <nb-icon
            *ngIf="
              !button?.buttonSuffixIconProps?.hidden &&
              button?.buttonSuffixIconProps?.icon
            "
            [icon]="button?.buttonSuffixIconProps?.icon"
            pack="fci"
            class="ml-2 cursor-pointer"
            [status]="button?.buttonSuffixIconProps?.status"
            (click)="onClickSuffixIcon(button)"
          >
          </nb-icon>
        </div>
      </ng-container>
    </div>
  </div>
</div>
